import React, { useEffect, useState } from "react";
import { withUser } from "@coverme/identity";
import { Birdseed } from "@coverme/elements";
import { connect } from "react-redux";
import * as retrocheckBillingActions from "../../actions/retrocheckBillingActions";
import "../../components/RetrocheckBilling/RetrocheckBilling.scss";
import { LoadingBar } from "../../components/LoadingComponents/LoadingBar";
import { Link } from "react-router-dom";
import { DashboardBanner } from "../../components/DashboardBanner/DashboardBanner";
import { useFilters } from "../../hooks/useFilters";
import { RetrocheckBillingTable } from "../../components/RetrocheckBilling/RetrocheckBillingTable";
import { RetrocheckFilters } from "../../components/Retrocheck/RetrocheckFilters";
import { postAndDownloadFilee } from "../../services/fileDownloader";

export const RetrocheckBillingComponent = ({ user, history, getFiles, customerId, files, updateRetrocheckFilter }) => {
    const [isDownloading, setisDownloading] = useState(false);
    const isLoading = false;
    // const { filters, setFilters, onFetchData } = useFilters({}, customerId, getFiles, 500, 5);

    function onDownload(fileId, fileName) {
        console.log(fileId);
        console.log(fileName);
        setisDownloading(true);
        postAndDownloadFilee(`/api/retrocheckbilling/file/record/${fileId}`, fileName || {}, {}, false, "record.csv");
        setisDownloading(false);
    }
    const { filters,setFilters, onFetchData } = useFilters(
        { },
        customerId,
        getFiles,
        500,
        5
    );

    return (
        <div>
            <LoadingBar isLoading={isLoading}>
                <Birdseed>
                    <Link to="/" className="link">
                        Home
                    </Link>
                    <a href="javascript:void(0)">Retrocheck Billing</a>
                </Birdseed>
                <DashboardBanner firstName={user.profile.given_name} showStartNewCase={false} />
                <div className="filters">
                    <h3>Filters</h3>
                    <RetrocheckFilters submitFilter={setFilters} />
                </div>

                <RetrocheckBillingTable 
                    onDownload={onDownload}
                    pagedFiles={files} 
                    onFetchData={onFetchData} 
                    isLoading={files.isLoading} 
                />
            </LoadingBar>
        </div>
    );
};

export const RetrocheckBillingComponentWithUser = withUser(RetrocheckBillingComponent);

export const RetrocheckBillingContainer = connect(
    state => ({
        files: state.retrocheckBillingFiles,
        customerId: state.customer?.data?.customer?.GlobalId,
    }),
    dispatch => ({
        getFiles: (customerId, query, cancellationToken) =>
            dispatch(retrocheckBillingActions.getFiles(customerId, query, cancellationToken)),
        updateRetrocheckFilter: (filter, query) => dispatch(retrocheckBillingActions.updateFileFilter(filter, query)),
    })
)(RetrocheckBillingComponentWithUser);
